import { memo } from 'react';
import { Handle, Position, NodeResizer } from '@xyflow/react';
import { Cloud } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface CloudGroupNodeData {
  id: string;
  label: string;
  provider?: string;
  region?: string;
}

interface CloudGroupNodeProps {
  data: CloudGroupNodeData;
  selected: boolean;
}

export const CloudGroupNode = memo(({ data, selected }: CloudGroupNodeProps) => {
  return (
    <>
      <NodeResizer
        minWidth={400}
        minHeight={300}
        isVisible={selected}
        lineClassName="border-primary border-2"
        handleClassName="h-6 w-6 bg-primary rounded-sm border-2 border-background cursor-nwse-resize"
      />
      <div className="w-full h-full rounded-lg border-2 border-dashed border-purple-500/70 dark:border-purple-400/70 bg-purple-50/50 dark:bg-purple-950/50 backdrop-blur-sm">
        <div className="flex items-center gap-2 px-4 py-2 bg-purple-100/60 dark:bg-purple-900/50 rounded-t-lg border-b border-purple-300/40 dark:border-purple-600/40">
          <Cloud className="h-5 w-5 text-purple-600 dark:text-purple-400" />
          <div className="flex-1">
            <div className="font-semibold text-sm">{data.label}</div>
            {data.region && (
              <div className="text-xs text-muted-foreground">{data.region}</div>
            )}
          </div>
          {data.provider && (
            <Badge variant="outline" className="border-purple-400/50 bg-purple-100/50 dark:bg-purple-900/50 text-purple-700 dark:text-purple-300">
              {data.provider}
            </Badge>
          )}
        </div>
      </div>

      <Handle id="top" type="source" position={Position.Top} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-purple-500 bg-purple-200 dark:bg-purple-700" />
      <Handle id="right" type="source" position={Position.Right} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-purple-500 bg-purple-200 dark:bg-purple-700" />
      <Handle id="bottom" type="source" position={Position.Bottom} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-purple-500 bg-purple-200 dark:bg-purple-700" />
      <Handle id="left" type="source" position={Position.Left} isConnectableStart={true} isConnectableEnd={true} className="w-3 h-3 border-2 border-purple-500 bg-purple-200 dark:bg-purple-700" />
    </>
  );
});

CloudGroupNode.displayName = 'CloudGroupNode';
